import React, { useState, useEffect } from 'react';
import { HubConnectionBuilder } from '@microsoft/signalr';
import { useHistory } from "react-router-dom";

//import Toast from 'react-bootstrap/Toast';

import authorizeService from './api-authorization/AuthorizeService';

import { ToastContainer, toast } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';

const NotificationPanel = (props) => {

    const [connection, setConnection] = useState(null);

    let history = useHistory()
    const navigate = (url) => {
        history.push(url);
    }

    useEffect(() => {

        let getUrl = window.location;
        let baseUrl = getUrl.protocol + "//" + getUrl.host;

        const newConnection = new HubConnectionBuilder()
            .withUrl(`${baseUrl}/hubs/notifications`, { accessTokenFactory: () => authorizeService.getAccessToken() })
            .withAutomaticReconnect()
            .build();

        setConnection(newConnection);
    }, []);

    useEffect(() => {
        if (connection) {
            connection.start()
                .then(result => {
                    console.log('Connected!');

                    connection.on('ReceiveNotification', notification => {
                        console.log(notification)
                        if (notification.type === 2) {
                            toast.success(notification.message, {
                                position: "top-right",
                                autoClose: 10000,
                                hideProgressBar: false,
                                closeOnClick: false,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                                onClick: ((clickInfo) => {
                                    navigate(`/scoring/${notification.data.fixtureRoomId}`);
                                }),
                            });
                        }
                    });
                })
                .catch(e => console.log('Connection failed: ', e));
        }
    }, [connection]);

    return (
        <div>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </div>
    );
}

NotificationPanel.displayName = NotificationPanel.name;

export default NotificationPanel;